import { GeneralReportStore } from "./../Stores/GeneralReportStore";
import { computed} from "mobx";


export class CompareReportStore extends GeneralReportStore {
    @computed get firstShotVideos() {
        if (this.selectedStrokesGroups && this.selectedStrokesGroups.length && this.selectedStrokesGroups[0].strokes && this.selectedStrokesGroups[0].strokes.length) {
            return this.selectedStrokesGroups[0].strokes[0].videos;
        }
        return [];
    };
    @computed get secondShotVideos() {
        if (this.selectedStrokesGroups && this.selectedStrokesGroups.length && this.selectedStrokesGroups[1].strokes && this.selectedStrokesGroups[1].strokes.length) {

            return this.selectedStrokesGroups[1].strokes[0].videos;
        }
        return [];
    };
}